module.exports = __webpack_public_path__ + "static/img/arrow_right.a340978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/arrow_right.png
// module id = 0r2I
// module chunks = 10